export const patternName = "carousel";

export type PatternName = typeof patternName;
